// export const apiConfig = {
//   baseURL: "https://api.vabenepizza.ch/api",
//   wssURL: "wss://api.vabenepizza.ch",
// };
// export const apiConfig = {
//   baseURL: "http://localhost:3002/api",
//   marketingURL: "http://localhost:3000/",
//   wssURL: "ws://localhost:3002",
// };
export const apiConfig = {
    baseURL: "https://api.appfood.io/api",
    marketingURL: "https://marketing-api.appfood.io/",
    wssURL: "wss://api.appfood.io",
};
// export const apiConfig = {
//   baseURL: "https://preprod-api.vabenepizza.ch/api",
//   wssURL: "wss://preprod-api.vabenepizza.ch",
// };
